import { z } from 'zod';
import { timestamp, nullableArray } from '@/lib/schemas/primitives';

export const backstageStatsSchema = z.object({
  totalUsers: z.number(),
  totalHouseholds: z.number(),
  totalExpenses: z.number(),
  totalRecurringBills: z.number(),
});
export type BackstageStats = z.infer<typeof backstageStatsSchema>;

export const backstageUserSchema = z.object({
  id: z.number(),
  name: z.string(),
  email: z.string(),
  householdId: z.number(),
  householdName: z.string(),
  createdAt: timestamp,
  hasBackstageAccess: z.boolean(),
});
export type BackstageUser = z.infer<typeof backstageUserSchema>;

export const backstageHouseholdMemberSchema = z.object({
  id: z.number(),
  name: z.string(),
  email: z.string(),
});
export type BackstageHouseholdMember = z.infer<typeof backstageHouseholdMemberSchema>;

export const backstageHouseholdSchema = z.object({
  id: z.number(),
  name: z.string(),
  members: nullableArray(backstageHouseholdMemberSchema),
  expenseCount: z.number(),
  billCount: z.number(),
});
export type BackstageHousehold = z.infer<typeof backstageHouseholdSchema>;
